export const createLiveSession = (courseId, data) => ({
  method: "POST",
  route: `${window.ENV?.API_URL}courses/${courseId}/live-sessions`,
  data,
});

export const setLiveSessionState = (liveSessionId, event) => ({
  method: "PATCH",
  route: `${window.ENV?.API_URL}live-sessions/${liveSessionId}/states/${event}`,
});
